/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainEntitiesDocumentsDocumentType } from './FxIdDomainEntitiesDocumentsDocumentType';
import {
    instanceOfFxIdDomainEntitiesDocumentsDocumentType,
    FxIdDomainEntitiesDocumentsDocumentTypeFromJSON,
    FxIdDomainEntitiesDocumentsDocumentTypeFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentTypeToJSON,
} from './FxIdDomainEntitiesDocumentsDocumentType';

/**
 * @type FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType
 * Тип документа.
 * @export
 */
export type FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType = FxIdDomainEntitiesDocumentsDocumentType;

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsDocumentType(json)) {
        return FxIdDomainEntitiesDocumentsDocumentTypeFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON(json: any): any {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainEntitiesDocumentsDocumentType(value)) {
        return FxIdDomainEntitiesDocumentsDocumentTypeToJSON(value as FxIdDomainEntitiesDocumentsDocumentType);
    }

    return {};
}

